import { render, staticRenderFns } from "./FunPreview.vue?vue&type=template&id=1a517ffb&"
import script from "./FunPreview.vue?vue&type=script&lang=js&"
export * from "./FunPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports